<div class="container" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <ng-container *ngIf="hasServiceCallLabel">
    <a class="btn" (click)="callService()">
      <span langkey="button_service" ng-reflect-key="button_service"></span><!--Service-->
      <div inlineSVG="sot/sot-icon.svg#sot-service" flex></div>
    </a>
  </ng-container>
  <a *ngIf="show_langauges_btn" class="btn langbtn" (click)="openChooseLanguages()">
    <span langkey="button_language" ng-reflect-key="button_language"></span><!--Sprachen-->
    <div inlineSVG="sot/sot-icon.svg#sot-language" flex></div>
  </a>

  <div class="languages" *ngIf="show_choose_languages" (click)="closeChooseLanguages()">
    <div class="language_content">
      <ng-container *ngFor="let language of languages">
        <a (click)="chooseLanguage(language.key)" [class]="'btn lang' + (language.active ? ' active' : '')">
          <div class="language_flag">
            <img *ngIf="language.key == 'de'" [src]="'./assets/core/sot/lang/de.jpg'" />
            <img *ngIf="language.key == 'en'" class="ya_image" [src]="language.image"
              error_src="./assets/core/sot/lang/en.jpg" />
            <img *ngIf="language.key != 'de' && language.key != 'en'" class="ya_image" [src]="language.image" />
          </div>
          <div class="language_name">
            <span class="language_text" style="-webkit-box-orient: vertical;">
              {{getLanguageText(language.key)}}
            </span>
          </div>
          <div class="language_checkmark">
            <div *ngIf="language.active" inlineSVG="sot/sot-icon.svg#sot-done" flex
              [setSVGAttributes]="{class: 'btn-icon'}"></div>
          </div>
        </a>
      </ng-container>
    </div>
  </div>
</div>